// extracted by mini-css-extract-plugin
export var formContainer = "_e5-0";
export var message = "_e5-1";